import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import '../styles/Legal.css';

const TermsOfService = () => (
  <main className="legal-page">
    <SEO
      title="Terms of Service | Bularis Tech"
      description="Review the terms that apply when using the Bularis Tech public website and submitting service or project inquiries."
      path="/terms-of-service"
    />

    <header className="legal-hero">
      <div className="legal-container">
        <span className="legal-eyebrow">Legal</span>
        <h1>Terms of Service</h1>
        <p>These terms apply to your use of the Bularis Tech public website. By using the website, you agree to use it responsibly and in accordance with these terms.</p>
        <p className="legal-date">Effective: August 31, 2026</p>
      </div>
    </header>

    <div className="legal-container legal-document">
      <section>
        <h2>Use of the website</h2>
        <p>You may use this website to learn about Bularis Tech, explore its services, solutions, and products, and submit genuine project or service inquiries. You are responsible for using the website lawfully and for ensuring that information you submit is accurate and appropriate.</p>
      </section>

      <section>
        <h2>Website information</h2>
        <p>The website provides general information about Bularis Tech and its capabilities. Content may be updated, corrected, or removed and should not be treated as a guaranteed specification, professional advice, or a binding offer.</p>
      </section>

      <section>
        <h2>Project and service inquiries</h2>
        <p>Submitting a Contact form or discussing a project does not by itself create a client relationship, guarantee acceptance of work, or form a binding service agreement. The scope, responsibilities, pricing, timing, ownership, support, and other commercial terms for development work must be agreed separately in an applicable proposal, statement of work, or client agreement.</p>
      </section>

      <section>
        <h2>Intellectual property</h2>
        <p>Unless otherwise stated, the website design, branding, written content, graphics, and other materials published by Bularis Tech are owned by or licensed to Bularis Tech. You may view and use the website for its intended informational purpose, but you may not reproduce, distribute, modify, or commercially exploit its materials without permission or another lawful basis.</p>
        <p>Ownership and licensing of work created for a client are governed by the relevant client agreement, not these website terms.</p>
      </section>

      <section>
        <h2>Acceptable use</h2>
        <p>You must not attempt to disrupt the website, gain unauthorized access, introduce malicious code, misuse the Contact form, impersonate another person, submit unlawful material, or use automated activity that unreasonably burdens the website or its services.</p>
      </section>

      <section>
        <h2>Third-party services and links</h2>
        <p>The website may depend on or link to third-party platforms and services. Bularis Tech does not control third-party websites and is not responsible for their availability, content, terms, or practices. Your use of a third-party service is governed by that provider’s terms.</p>
      </section>

      <section>
        <h2>Availability and limitation of liability</h2>
        <p>Bularis Tech aims to keep the website useful and available, but does not promise uninterrupted or error-free access. To the extent reasonably permitted, Bularis Tech is not responsible for indirect or consequential loss arising solely from use of, inability to use, or reliance on this public website or third-party links.</p>
        <p>Nothing in these website terms replaces obligations expressly agreed in a separate client agreement or excludes responsibilities that cannot lawfully be excluded.</p>
      </section>

      <section>
        <h2>Website and service changes</h2>
        <p>Bularis Tech may change, suspend, or discontinue website content, features, or descriptions as its services and products evolve. Such changes do not alter an existing signed client agreement unless separately agreed.</p>
      </section>

      <section>
        <h2>Updates to these terms</h2>
        <p>These terms may be updated from time to time. The effective date above will be revised when material updates are published. Continued use of the website after an update means the revised website terms apply to that use.</p>
      </section>

      <section>
        <h2>Contact Bularis Tech</h2>
        <p>If you have a question about these terms or want to discuss a project, use the <Link to="/contact">Bularis Tech Contact page</Link>.</p>
      </section>
    </div>
  </main>
);

export default TermsOfService;
